/**
 * @module public/js/utils/tenantUtils.js
 * @summary Helper utilities for resolving the active tenant context in the UI.
 */

/**
 * Resolve the active tenant identifier from DI services or browser hints.
 *
 * @param {{ tenant?: { getTenantId?: () => string }, auth?: { currentUser?: { tenantId?: string } } }} [context]
 *   Optional context containing DI tenant/auth services.
 * @returns {string} The resolved tenant identifier or an empty string when unavailable.
 */
export function resolveActiveTenantId(context = {}) {
  const { tenant = null, auth = null } = context;

  const tenantIdFromHook = tenant?.getTenantId?.() || null;
  const tenantIdFromAuth = auth?.currentUser?.tenantId ?? null;

  let tenantIdFromStorage = null;
  if (typeof window !== 'undefined') {
    const local = window.localStorage?.getItem?.('activeTenant') || null;
    const session = window.sessionStorage?.getItem?.('topsail__tenant') || null;
    tenantIdFromStorage = local || session;
  }

  let tenantIdFromDom = null;
  if (typeof document !== 'undefined') {
    tenantIdFromDom = document.body?.dataset?.tenantId || null;
  }

  return (
    tenantIdFromHook ||
    tenantIdFromAuth ||
    tenantIdFromStorage ||
    tenantIdFromDom ||
    ''
  );
}
